/* Copyright (c) 2022-2023 VMware, Inc. All rights reserved. -- VMware Confidential */

export class NavUtils {

    public static openExternalLink(url: string): void {
        window.open(url, "_blank").focus();
    }

    public static closeWindow(): void {
        window.self.close();
    }
}
